/**
 * SubservicesSection — secondary «Подуслуги» navigation section. Moved out
 * of ServiceManagementPage.tsx (KAN-157 god-component split).
 *
 * A parent service is an ordinary calculator (its formula is shown by
 * CalculatorDetails). This section is rendered BENEATH that calculator body
 * purely for navigation: a list of child links (name + real type badge) that
 * select the child when clicked. Rendered only when the service has
 * children; the caller guards on that condition too.
 */
import { Badge } from '@/components/ui/badge';
import type { Service } from '@/services/api/services';
import { serviceTypeLabel, serviceTypeVariant } from '@/utils/serviceFormula';

export function SubservicesSection({
  service,
  childrenByParent,
  onSelect,
}: {
  service: Service;
  childrenByParent: Map<number, Service[]>;
  onSelect: (service: Service) => void;
}): JSX.Element | null {
  const children = childrenByParent.get(service.id) || [];
  if (children.length === 0) return null;

  return (
    <div data-testid="subservices-section" className="space-y-1">
      {/* No «Подуслуги» word here — the section's DetailSection <h4> already
          carries it; a second «Подуслуги» text would make
          within(section).getByText(/Подуслуги/i) throw. We just show the count. */}
      <div className="text-xs font-medium text-gray-500 mb-1">{children.length} услуг</div>
      <ul className="space-y-1">
        {children.map(child => (
          <li key={child.id}>
            <button
              onClick={() => onSelect(child)}
              className="flex items-center gap-2 text-sm text-blue-600 hover:underline">
              {child.name}
              <Badge variant={serviceTypeVariant(child)}>{serviceTypeLabel(child)}</Badge>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
